import {
  LicenseCode,
  LicensePaymentStatus,
  OwnershipType,
  Region,
  SubscriptionPeriodicity,
} from "Infrastructure/Api/Api";
import { z } from "zod";

export const partyLicenseSchema = z.object({
  publicID: z.string(),
  code: z.enum(LicenseCode),
  licenseNo: z.string().nullish(),
  region: z.enum(Region).nullish(),
  transactionPublicID: z.string().nullish(),
  paymentStatus: z.enum(LicensePaymentStatus),
  subscriptionPeriodicity: z.enum(SubscriptionPeriodicity).nullish(),
  ownWallet: z.enum(OwnershipType),
  walletAddress: z.string().nullish(),
});
